const prepareProductUrl = productUrl => {
    let domainPath = "https://www.laticrete.com"
    let urlPath = window.location.href.toLowerCase();
    let url;

    

    if (urlPath.indexOf("eu.") > -1 || urlPath.indexOf("europeauthor") > -1 || urlPath.indexOf("sc_site=europe") > -1) {
        domainPath = "eu.laticrete.com";
        url = productUrl.replace('europeauthor.laticrete.com', domainPath);
        console.log(url);
        return url;
    }
    else if (urlPath.indexOf("au.") > -1 || urlPath.indexOf("australiaauthor") > -1 || urlPath.indexOf("sc_site=australia") > -1) {
        domainPath = "au.laticrete.com";
        url = productUrl.replace('australiaauthor.laticrete.com', domainPath);
        return url;
    } else {
        url = productUrl.replace('/en/sitecore/content/north-america/home', domainPath);
        url = url.replace('author', 'www');
        return url;
    }
}

export { prepareProductUrl }


// WEBPACK FOOTER //
// ./src/services/helpers.js